import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyB_ZZ0beCte9ywbK8VOnUYMi1YZXt11Kzk',
  authDomain: 'getcloudd.firebaseapp.com',
  projectId: 'getcloudd',
  storageBucket: 'getcloudd.firebasestorage.app',
  messagingSenderId: '722693792192',
  appId: '1:722693792192:web:018fb0167aef8745a32825',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
